import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({directives:[{name:"maska",rawName:"v-maska:[options]",arg:_vm.options}],attrs:{"data-maska":_vm.mask,"data-maska-tokens":"0:\\d:multiple|9:\\d:optional","value":_vm.amount,"outlined":"","prefix":_vm.currentCurrencySymbol,"hide-details":"auto"},on:{"input":_vm.setAmount}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }